import { ClientWorkspace } from './workspace.type';

export function sortWorkspacesAlphabeticallyImmutable(
	workspaces: ClientWorkspace[]
): ClientWorkspace[] {
	return [...workspaces].sort(sortWorkspacesAlphabeticallyFn);
}

export function sortWorkspacesAlphabeticallyFn(
	workspaceA: ClientWorkspace,
	workpaceZ: ClientWorkspace
): number {
	return workspaceA.name.localeCompare(workpaceZ.name);
}
